import React from 'react';
import { withStyles } from '@material-ui/core';
import { Modal } from '@orijinworks/frontend-commons';
import styles, { ExportModalStyles } from './ExportAllWithEmail.styles';
import { useExportAllWithEmailHook, MAX_EMAILS } from './useExportAllWithEmailHook';
import ExportFormSection from './ExportFormSection';
import ExportSuccessMessage from './ExportSuccessMessage';

const ExportAllWithEmail = ({ classes, open = false, onClose, onExport, isSuccess }) => {
    const {
        modalRef,
        emails,
        password,
        showPassword,
        isFormValid,
        passwordError,
        handleAddEmail,
        handleEmailChange,
        handleClose,
        handleContinue,
        handlePasswordChange,
        handleToggleShowPassword,
        isValidEmail,
    } = useExportAllWithEmailHook({ open, onClose, onExport });

    return (
        <Modal
            ref={modalRef}
            open={open}
            onClose={handleClose}
            onContinue={handleContinue}
            heading={isSuccess ? 'Success' : 'Export'}
            labelledBy={isSuccess ? 'Success' : 'Export'}
            describedBy="Export data with email and file password"
            cancelBtnText="Cancel"
            actionBtnText="Export"
            actionBtnId="export-all-with-email-continue-btn"
            showCrossIcon
            modalType={{ type: 'normal', status: 'info', size: 'medium' }}
            continueButtonProps={{ disabled: !isFormValid }}
            styles={{ mainWrapperStyles: { width: 532 } }}
            mainModalStyles={ExportModalStyles}
            showFooter={!isSuccess}
        >
            {isSuccess ? (
                <ExportSuccessMessage />
            ) : (
                <ExportFormSection
                    classes={classes}
                    emails={emails}
                    maxEmails={MAX_EMAILS}
                    password={password}
                    showPassword={showPassword}
                    passwordError={passwordError}
                    handleEmailChange={handleEmailChange}
                    handleAddEmail={handleAddEmail}
                    handlePasswordChange={handlePasswordChange}
                    handleToggleShowPassword={handleToggleShowPassword}
                    isValidEmail={isValidEmail}
                />
            )}
        </Modal>
    );
};

ExportAllWithEmail.defaultProps = {
    open: false,
    onClose: undefined,
    onExport: undefined,
    isSuccess: false,
};

export default withStyles(styles)(ExportAllWithEmail);
